export default [
  {
    displayName:
      "Extension of fiber optic coverage to promote national interconnection",
    baseCountry: "Gabon",
    sector: "Information technology",
    summary:
      "This project aims at extending the national fiber optic coverage for a national interconnection.",
    targetRegion: "Nationale",
    debtType: ["ppp"],
    isEquityInvestment: true,
    isDebtInvestment: true,
    finsoughtCurrency: "XAF 100000000 (2022)",
    dealRanges: "00001_00005",
    materials: ["Feasibility studies"],
  },
  {
    displayName:
      "Construction of a data center to facilitate digitalization of government services",
    baseCountry: "Gabon",
    sector: "Information technology",
    targetRegion: "Libreville (Estuaire)",
    debtType: ["ppp"],
    summary:
      "Within the framework of the BackBone 4 project,  the construction of a data center aims to host government applications and digitalized public services in a secure environment offering a high level of service quality.",
    isEquityInvestment: true,
    isDebtInvestment: false,
    finsoughtCurrency: "XAF 6000000000 (2022)",
    dealRanges: "00001_00005",
    materials: ["Pre-feasibility studies"],
  },
];
